(function () {
  try {
    const config = window.__autoCartAddConfig;
    if (!config || !config.enabled) return;

    let configuredItems = [];
    if (Array.isArray(config.items)) {
      configuredItems = config.items;
    } else if (config.variantId != null && config.threshold != null) {
      configuredItems = [{ variantId: config.variantId, threshold: config.threshold }];
    }

    const autoAddItems = normalizeAutoAddItems(configuredItems);
    if (!autoAddItems.length) return;

    const autoVariantIds = new Set(autoAddItems.map((item) => item.variantId));
    // hediyeyi_cikar: bu script'in eklediği hediyeler sepet attribute'unda tutulur. Şart bozulunca yalnızca
    // bunlardan 1 adet çıkarılır; müşterinin kendi aldığı / artırdığı adetlere dokunulmaz.
    const ADDED_ATTRIBUTE = '_hediye_otomatik_eklenen';
    let staleRetries = 0;
    let isProcessing = false;
    let pendingCheck = false;
    let autoCheckLocked = false;

    function normalizeAutoAddItems(items) {
      const itemMap = new Map();

      for (const item of items) {
        if (item === null || typeof item !== 'object') continue;

        const threshold = Number(item.threshold);
        const variantIdParsed = parseInt(String(item.variantId ?? '').trim(), 10);

        if (!Number.isFinite(threshold) || threshold <= 0) continue;
        if (!Number.isFinite(variantIdParsed) || variantIdParsed <= 0) continue;

        const variantId = String(variantIdParsed);

        const existingItem = itemMap.get(variantId);
        if (existingItem && existingItem.threshold <= threshold) continue;

        itemMap.set(variantId, { variantId, threshold });
      }

      return [...itemMap.values()];
    }

    function lockAutoCheck() {
      if (!autoCheckLocked) {
        autoCheckLocked = true;
        window.cartMutationLock?.lock();
      }
    }

    async function getCart() {
      const res = await fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' }
      });
      return res.json();
    }

    async function getCollectionProductIds() {
      const sectionId = 'hediye-otomatik-sepet-urunleri';
      const res = await fetch(`${window.routes.cart_url}?sections=${sectionId}`);
      const sections = await res.json();
      const doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');

      return new Set(doc.body.textContent.split(',').map((id) => id.trim()).filter(Boolean));
    }

    async function addProducts(items) {
      const lineItems = [];
      for (const item of items) {
        const id = parseInt(String(item.variantId), 10);
        if (!Number.isFinite(id) || id <= 0) continue;
        lineItems.push({ id, quantity: 1 });
      }
      if (!lineItems.length) return {};

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lineItems })
      });

      return res.json();
    }

    async function updateCart(body) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error(`cart/update.js ${res.status}`);

      return res.json();
    }

    function hasProperties(line) {
      return Object.keys(line.properties ?? {}).length > 0;
    }

    function cartSignature(cart) {
      return (cart.items ?? []).map((line) => `${line.key}:${line.quantity}`).join('|');
    }

    function notifyCartChanged() {
      // Update cart drawer if it exists (non-cart pages)
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.fetchAndUpdateCart === 'function') {
        cartDrawer.fetchAndUpdateCart();
      }

      // Update cart page items if it exists (cart page)
      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.updateAllCartSections === 'function') {
        cartItems.updateAllCartSections();
      }
    }

    async function checkAndUpdate() {
      if (isProcessing) {
        pendingCheck = true;
        return;
      }
      isProcessing = true;

      try {
        const cart = await getCart();
        const cartLines = cart.items ?? [];
        // Koleksiyon filtresi varsa barem yalnızca koleksiyondaki satırlardan hesaplanır
        const collectionProductIds = config.filterByCollection ? await getCollectionProductIds() : null;

        // Calculate cart total EXCLUDING the auto-add products
        const autoProductsInCart = new Set();
        // Script hediyeyi property'siz ekler; aynı varyantın property'li satırı (ön sipariş vb.) müşterinindir
        const plainAutoProductsInCart = new Set();
        let totalWithoutAutoProducts = 0;

        for (const item of cartLines) {
          const variantId = String(item.variant_id);

          if (autoVariantIds.has(variantId)) {
            autoProductsInCart.add(variantId);
            if (!hasProperties(item)) plainAutoProductsInCart.add(variantId);
          } else if (!collectionProductIds || collectionProductIds.has(String(item.product_id))) {
            totalWithoutAutoProducts += item.final_line_price;
          }
        }

        const itemsToAdd = autoAddItems.filter((item) => {
          const aboveThreshold = totalWithoutAutoProducts >= item.threshold;

          return aboveThreshold && !autoProductsInCart.has(item.variantId);
        });

        const trackAdded = config.removeBelowThreshold === true;
        const savedAttribute = String(cart.attributes?.[ADDED_ATTRIBUTE] ?? '');
        let writtenAttribute = savedAttribute;
        // Property'siz satırı kalmayan kayıtlar düşülür. Takip kapalıyken kayıt tamamen silinir; tekrar açılınca
        // müşterinin arada kendi aldığı adet script'in eklediği sanılmasın
        const addedVariantIds = new Set(
          trackAdded ? savedAttribute.split(',').filter((id) => plainAutoProductsInCart.has(id)) : []
        );
        const updates = {};

        for (const item of trackAdded ? autoAddItems : []) {
          if (totalWithoutAutoProducts >= item.threshold || !addedVariantIds.has(item.variantId)) continue;

          const line = cartLines.find(
            (cartLine) => String(cartLine.variant_id) === item.variantId && !hasProperties(cartLine)
          );
          updates[line.key] = line.quantity - 1;
          addedVariantIds.delete(item.variantId);
        }

        // Çıkarma eklemeden önce ve attribute ile aynı istekte yapılır: hediye eklenince indirim dağılımı
        // değişip satır key'leri değişebilir, ayrı istekte attribute yazılamazsa adet tekrar düşebilir
        const hasRemovals = Object.keys(updates).length > 0;
        if (hasRemovals) {
          // updates mutlak adet yazar; okumadan bu yana (koleksiyon isteği sürerken) müşteri sepeti
          // değiştirdiyse onun değişikliğini ezmemek için yazılmaz, sepet yeniden kontrol edilir
          if (cartSignature(await getCart()) !== cartSignature(cart)) {
            // Sınırsız döngüye girmemek için en fazla 2 kez hemen yeniden denenir; sonrası bir sonraki sepet olayına kalır
            if (staleRetries < 2) {
              staleRetries++;
              pendingCheck = true;
            }
            return;
          }
          staleRetries = 0;
          writtenAttribute = [...addedVariantIds].join(',');
          await updateCart({ updates, attributes: { [ADDED_ATTRIBUTE]: writtenAttribute } });
        }

        if (itemsToAdd.length) {
          const result = await addProducts(itemsToAdd);
          if (trackAdded) {
            for (const line of result.items ?? []) addedVariantIds.add(String(line.variant_id));
          }
        }

        // Sepet görünümü kayıt yazımından önce tazelenir; kayıt yazılamasa da eklenen hediye ekranda görünür
        if (hasRemovals || itemsToAdd.length) {
          notifyCartChanged();
        }

        const nextAttribute = [...addedVariantIds].join(',');
        if (nextAttribute !== writtenAttribute) {
          await updateCart({ attributes: { [ADDED_ATTRIBUTE]: nextAttribute } });
        }
        // Kullanıcı manuel olarak hediye ürün miktarını artırdıysa dokunma
      } catch (err) {
        console.error('[Auto Cart Add] Error:', err);
      } finally {
        isProcessing = false;
        autoCheckLocked = false;
        window.cartMutationLock?.unlock();

        if (pendingCheck) {
          pendingCheck = false;
          lockAutoCheck();
          checkAndUpdate();
        }
      }
    }

    function debounceAutoCart(fn, delay) {
      let timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }

    const debouncedCheck = debounceAutoCart(checkAndUpdate, 600);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'auto-cart-add') return;
        lockAutoCheck();
        debouncedCheck();
      });
    }

    document.addEventListener('cart:updated', (e) => {
      if (e.detail && e.detail.source === 'auto-cart-add') return;
      lockAutoCheck();
      debouncedCheck();
    });

    checkAndUpdate();
  } catch (err) {
    console.error('[Auto Cart Add] Init error:', err);
  }
})();
